











































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { BIcon, BIconXSquareFill, BIconSearch } from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconXSquareFill,
    BIconSearch,
  },
})
export default class Galery extends Vue {
  // export default==protected class
  protected image = "";
  protected clicked = "";
  protected bool = false;

  protected toogle(srcImg: string): void {
    if (this.bool == false) {
      this.clicked = srcImg;
      this.bool = true;
    } else if (this.clicked == srcImg) {
      this.clicked = "";
      this.bool = false;
    } else {
      this.clicked = srcImg;
    }
  }
  protected erased(): void {
    this.clicked = "";
    this.bool = false;
  }

  @Prop() protected readonly galeryPicture!: string[]; //tableau de donnée
  @Prop() protected readonly classheight!: string; //donnée
}
